import React from "react";
import RankedItemsReport from "../../components/Report/RankedItemsReport";

const MostReturnedReportPage: React.FC = () => <RankedItemsReport variant="most-returned" />;
export default MostReturnedReportPage;
